import type { GuestCommunicationChannel, GuestCommunicationMessageKey } from '@/shared/api';

export const MESSAGE_PRESENTATION: Record<
  GuestCommunicationMessageKey,
  { title: string; when: string; description: string }
> = {
  Welcome: {
    title: 'Willkommensnachricht',
    when: 'Sofort nach der Buchung',
    description: 'Öffnet den sicheren Zugang zum Gastportal und bleibt deshalb immer aktiv.',
  },
  Reminder5d: {
    title: 'Fünf Tage vor Anreise',
    when: 'Fünf Tage vor der Anreise',
    description: 'Erinnert rechtzeitig an das noch offene Onboarding.',
  },
  Reminder1d: {
    title: 'Am Vortag',
    when: 'Am Tag vor der Anreise',
    description:
      'Letzte Erinnerung für Gäste, die rechtzeitig gebucht haben. Wer sie bekommt, erhält keine am Anreisetag.',
  },
  ArrivalDayNudge: {
    title: 'Am Anreisetag',
    when: 'Ab dem Anreisetag',
    description:
      'Letzte Erinnerung, wenn der Vortag schon vorbei war – etwa bei kurzfristigen Buchungen. Statt der Vortags-Erinnerung, nie zusätzlich.',
  },
  PostStay: {
    title: 'Nach dem Aufenthalt',
    when: 'Nach der Abreise',
    description: 'E-Mail nach der Abreise; über OTA wird hier nichts versendet.',
  },
};

export const CHANNEL_LABEL: Record<GuestCommunicationChannel, string> = {
  Email: 'E-Mail',
  Ota: 'OTA-Nachricht',
};

/** Dieselben Beispielwerte wie in der Servervorschau — nie echte Gastdaten. */
export const exampleValues = (objectName?: string): Record<string, string> => ({
  '{{GastVorname}}': 'Max',
  '{{Apartment}}': 'Apartment 02',
  '{{Objekt}}': objectName ?? 'Ihr Objekt',
  '{{Anreisedatum}}': '18.09.2026',
  '{{Abreisedatum}}': '01.10.2026',
  '{{GastportalLink}}': 'persönlicher Link',
});
